<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="状态">
        <el-select v-model="status" placeholder="状态" clearable>
          <el-option label="待审核" :value="0"></el-option>
          <el-option label="通过" :value="2"></el-option>
          <el-option label="拒绝" :value="1"></el-option>
          <el-option label="冻结" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #activity_time="{ row }">
        <div>
          <p>开始:{{ row.start_time }}</p>
          <p>结束:{{ row.end_time }}</p>
        </div>
      </template>
      <template #status="{ row }">
        <div>
          <el-tag type="info" size="small" v-if="row.status === 0"
            >待审核</el-tag
          >
          <el-tag type="success" size="small" v-if="row.status === 2"
            >通过</el-tag
          >
          <el-tag type="danger" size="small" v-if="row.status === 1"
            >审核拒绝</el-tag
          >
          <el-tag type="danger" size="small" v-if="row.status === 3"
            >冻结</el-tag
          >
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button
            v-if="row.status == 3"
            type="success"
            size="small"
            @click="updateStatus(row, 2)"
            >解冻</el-button
          >

          <el-button
            v-if="row.status == 2"
            type="warning"
            size="small"
            @click="updateStatus(row, 3)"
            >冻结</el-button
          >
          <el-button type="success" size="small" @click="details(row)"
            >详情</el-button
          >
        </div>
      </template>
    </auto-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DataList: [],
      Option: [
        { name: "名称", value: "team_name" },
        { name: "人数", value: "team_size" },
        { name: "类型", value: "team_type" },
        { name: "擅长方向", value: "specialty_categories" },
        { name: "城市", value: "service_areas" },
        { name: "状态", value: "status", type: "custom" },
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: "",
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    details(row){
      let query = {
      id : row.id
      }
      this.$router.push({name:'enrollTeam_d',query});
    },
    addNew() {
      this.$refs.add.open();
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/enrollTeams/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          status: this.status,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
    updateStatus(row,status){
      this.$post("/user/enrollTeams/update", {
        id: row.id,
        status,
      }).then((res) => {
        this.$message("成功");
        row.status = status;
      });
    }
  },
};
</script>

<style lang="less" scoped>
</style>